<template>
  <div id="app">
    <div class="main-container">
      <nav-bar />
      <div class="router-view">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { fetchAverages } from "@/utils/api";

export default {
  name: "App",
  components: {
    NavBar
  },
  created() {
    this.queryAverageRiskData();
  },
  methods: {
    queryAverageRiskData() {
      this.$store.commit("setAverageLoading", true);
      fetchAverages()
        .then(response => this.$store.commit("updateAverageRisk", response))
        .finally(() => this.$store.commit("setAverageLoading", false));
    }
  }
};
</script>

<style lang="scss">
.router-view {
  margin-top: 80px;
  padding: 40px;
}
</style>
